import type { QueryClient } from "@tanstack/react-query"
import { redirect, type ParsedLocation } from "@tanstack/react-router"

import { optionalSession } from "@/app/optional-session"
import { signInPath } from "@/lib/sign-in-path"

export async function requireSession(
  queryClient: QueryClient,
  location: ParsedLocation
) {
  const session = await optionalSession(queryClient)

  if (!session) {
    throw redirect({
      to: signInPath(location.pathname),
      search: { redirect: location.href },
    })
  }

  return { session }
}
